// Phase 99 — Quick Add Task's 3 project dropdowns (header filter, create-row
// picker, per-row "move to project" chip) all use this shared component:
// grouped by Category (Client Delivery / Studio Operations / Marketing &
// Sales) and Active-projects-only, styled consistently with the app's
// orange-accented Select everywhere else.
import React, { useMemo } from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { isActiveProject, groupProjectsByCategory, PROJECT_CATEGORIES } from "@/lib/projectCategory";

export default function CategorizedProjectSelect({
  projects, value, onChange, placeholder = "Pick a project", topOption, className, testId, keepProjectId,
}) {
  const options = useMemo(() => {
    let list = (projects || []).filter(isActiveProject);
    // Edge case: a task already linked to a now-inactive project must keep
    // showing that project so the current value doesn't silently blank out.
    if (keepProjectId && !list.some((p) => p.id === keepProjectId)) {
      const current = (projects || []).find((p) => p.id === keepProjectId);
      if (current) list = [...list, current];
    }
    return groupProjectsByCategory(list);
  }, [projects, keepProjectId]);

  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className={className || "h-8 rounded-sm text-sm"} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {topOption && <SelectItem value={topOption.value}>{topOption.label}</SelectItem>}
        {PROJECT_CATEGORIES.map(({ value: cat, label }) => (
          options[cat].length > 0 && (
            <SelectGroup key={cat}>
              <SelectLabel className="text-[10px] uppercase tracking-wider text-[#F54800] font-bold">{label}</SelectLabel>
              {options[cat].map((p) => (
                <SelectItem key={p.id} value={p.id} data-testid={testId ? `${testId}-opt-${p.id}` : undefined}>
                  {p.name}
                </SelectItem>
              ))}
            </SelectGroup>
          )
        ))}
      </SelectContent>
    </Select>
  );
}
